import { render, staticRenderFns } from "./msButton.vue?vue&type=template&id=b08ee338&scoped=true"
import script from "./msButton.vue?vue&type=script&lang=js"
export * from "./msButton.vue?vue&type=script&lang=js"
import style0 from "./msButton.vue?vue&type=style&index=0&id=b08ee338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08ee338",
  null
  
)

export default component.exports